module.exports = __webpack_public_path__ + "img/share_modle_shanghai@2x.6d5d4b76.png";